import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Copyright from '../../internals/components/Copyright';
import TransaksiDisplay from './TransaksiDisplay';

export default function MainGridTransaksi({ category }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: { sm: '100%', md: '1700px' }, // Responsive width
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto', // Center content horizontally
      }}
    >
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{
          mb: (theme) => theme.spacing(2),
          alignItems: 'flex-start', // Align items to the top
          justifyContent: 'center', // Center content horizontally
          overflowX: 'auto', // Prevent horizontal overflow
        }}
      >
        <Grid item xs={12} sm={10} md={8}>
          {/* Adjust column widths to handle responsiveness */}
          <TransaksiDisplay />
        </Grid>
      </Grid>
      <Copyright sx={{ my: 4, textAlign: 'center' }} />
    </Box>
  );
}
